import { displayStoreWithStock } from "@/data/types/Store";
import { Box, Button, Stack, Typography } from "@mui/material";
import { FC, useContext } from "react";
import { StoreStockDetailsDisplay } from "./StoreStockDetailsDisplay";
import { useLocalization } from "@/data/Localization";
import { useClickAndCollect } from "@/data/Content/ClickAndCollect";
import { ContentContext } from "@/data/context/content";
import {changeStoreLinkSx} from "../styles/storeDetailsDisplay";

type Props = {
    setSelectedStore:(store:displayStoreWithStock|undefined)=>void
    page?:string;
}

export const SelectedStoreDisplay:FC<Props> = ({setSelectedStore, page}) => {
    const ccTextNLS = useLocalization("ClickAndCollect");
    const {selectedStoreCC} = useContext(ContentContext) as ReturnType<typeof useClickAndCollect>;
    const {store, stock, feature:storeFeature} = selectedStoreCC??{} as displayStoreWithStock;
    return(
        <Box>
            <Typography variant="h4" pb={1}>{ccTextNLS.YourSelectedStore.t()}</Typography>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Box>
                    <Typography variant="h4" pb={0}>
                        {store.storeName}{store.distance && <>&#40;{parseFloat(store.distance).toFixed(2)}km&#41;</>}
                    </Typography>
                    <Stack>
                        <Box>
                            <Typography>{store.displayAddress} {store.city}</Typography>
                        </Box>
                        <StoreStockDetailsDisplay {...{store, stock, storeFeature}} />
                    </Stack>
                </Box>
                {page!=='CHECKOUT' && 
                    <Button 
                        variant="textButton"
                        sx={changeStoreLinkSx} 
                        onClick={()=>setSelectedStore(undefined)}
                    >
                        {ccTextNLS.Actions.ChangeStore.t()}
                    </Button>
                }
            </Stack>
        </Box>
    )
}